/**
 * html2pdf paginates the full canvas, including padding and rounding overflow.
 * Remove only slices with no visible pixels, using the same page-height math
 * as html2pdf. Inspect before JPEG encoding so compression cannot hide content.
 */
export function removeBlankPdfPages(canvas, pdf, pageRatio) {
  const pageHeight = Math.floor(canvas.width * pageRatio);
  if (!pageHeight || !canvas.height) return;
  const pageCount = Math.ceil(canvas.height / pageHeight);
  if (pageCount <= 1 || pdf.internal.getNumberOfPages() !== pageCount) return;

  const context = canvas.getContext('2d');
  if (!context) return;
  const blankPages = [];
  try {
    for (let page = 0; page < pageCount; page++) {
      const end = Math.min((page + 1) * pageHeight, canvas.height);
      let blank = true;
      // Small strips avoid allocating another full-resolution report image.
      for (let y = page * pageHeight; y < end && blank; y += 64) {
        const { data } = context.getImageData(0, y, canvas.width, Math.min(64, end - y));
        for (let i = 0; i < data.length; i += 4) {
          if (data[i + 3] !== 0 &&
              (data[i] !== 255 || data[i + 1] !== 255 || data[i + 2] !== 255)) {
            blank = false;
            break;
          }
        }
      }
      if (blank) blankPages.push(page + 1);
    }
  } catch (_) {
    // A canvas that cannot be read must never cause report content to be lost.
    return;
  }

  // Delete backwards so original page numbers remain valid. Keep at least one.
  for (const page of blankPages.reverse()) {
    if (pdf.internal.getNumberOfPages() > 1) pdf.deletePage(page);
  }
}
